<template>
    <div>
        <!-- <h1>简历基础信息</h1> -->

        <el-row class="pOverview viewDetail">
            <el-col :span="4">
                <!--头像-->
                <div class="uImg">
                    <img src="@/pages/frontend/assets/images/defaultHeadIcons.png"/>
                    <!--<div v-else class="noImg"><i class="el-icon-user-solid"></i></div>-->
                </div>
            </el-col>
            <el-col :span="20">
                <h1>{{baseInfo.username}}</h1>
                <p class="tit">
                    <!--性别-->
                    <span>
                        <span>{{ dictFormatter(genderOptions, baseInfo.gender) }}</span>
                    </span>
                    <!--年龄-->
                    <span>{{this.getAge()}}岁</span>
                    <!--现居住地-->
                    <span>{{ arrayFormatter(baseInfo.address) }}</span>
                    <!--工作经验-->
                    <span>{{ baseInfo.exp }}</span>
                    <!--政治面貌-->
                    <span>
                        <span>{{ dictFormatter(politicalStatusOptions, baseInfo.politicalStatus) }}</span>
                    </span>
                </p>
                <!--个人优势-->
                <p class="intro">{{baseInfo.selfEvaluation}}</p>
            </el-col>
        </el-row>

        <div class="resumeOther">
            <el-row>
                <el-col :span="4" class="resumeItem">
                    <h1>求职意向</h1>
                </el-col>
                <el-col :span="20">
                    <el-col :span="12">
                        <p><b class="expectPosition">{{ jsonArrayFormatter(baseInfo.expectPosition) }}</b></p>
                        <p>
                            <span>工作性质：</span>
                            <span>{{ dictFormatter(willNatureOptions, baseInfo.willNature) }}</span>
                        </p>
                        <p>
                            <span>工作地区：</span>
                            <span>{{ arrayFormatter(baseInfo.city) }}</span>
                        </p>
                    </el-col>
                    <el-col :span="12">
                        <p><b>{{baseInfo.willSalaryStart}}-{{baseInfo.willSalaryEnd}}元•月</b></p>
                        <p>
                            <span>期望行业：</span>
                            <span>{{ jsonArrayFormatter(baseInfo.expectIndustry) }}</span>
                        </p>
                        <p>
                            <span>到岗时间：</span>
                            <span>{{baseInfo.arrivalTime}}</span>
                        </p>
                    </el-col>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import {getTreeListByDictType} from '@/api/dict';

    export default {
        props: ['baseInfo'],
        data() {
            return {
                genderOptions: [],  // 性别
                politicalStatusOptions: [],    // 政治面貌
                willNatureOptions: [],  // 工作性质
            }
        },
        created() {
            this.loadDictData();
        },
        computed: {
            location() {
                return function (avatar) {
                    let imagePath = encodeURI(avatar);
                    return `/files?imagePath=${imagePath}`;
                }
            }
        },
        methods: {
            loadDictData(){
                getTreeListByDictType("sex").then(response => {
                    this.genderOptions = response.data
                });
                getTreeListByDictType("political_outlook").then(response => {
                    this.politicalStatusOptions = response.data
                });
                getTreeListByDictType("work_nature").then(response => {
                    this.willNatureOptions = response.data
                });
            },
            // 出生日期换算年龄
            getAge() {
                //出生时间 毫秒
                var birthDayTime = new Date(this.baseInfo.birthday).getTime();
                //当前时间 毫秒
                var nowTime = new Date().getTime();
                //一年毫秒数(365 * 86400000 = 31536000000)
                return Math.ceil((nowTime - birthDayTime) / 31536000000);
            },
            arrayFormatter(data){
                if(!data) {
                    return '';
                }else {
                    return data.join('');
                }
            },
            jsonArrayFormatter(data) {
                if (!data) {
                    return '';
                }else {
                    return JSON.parse(data).join('/');
                }
            }
        },
    }
</script>
